import { render, staticRenderFns } from "./Scientific_consultant.vue?vue&type=template&id=4f0aab56&scoped=true"
import script from "./Scientific_consultant.vue?vue&type=script&lang=js"
export * from "./Scientific_consultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0aab56",
  null
  
)

export default component.exports